import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Settings24Regular,
  Info24Regular,
  ArrowExitRegular,
} from '@fluentui/react-icons';
interface IProps {
  logout?: () => void;
  setCloseSettingsPanel: (value: boolean) => void;
  minimalView: boolean;
}
export const SettingMenu = (props: IProps): React.ReactElement => {
  const { setCloseSettingsPanel, logout, minimalView } = props;
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-3 mt-4 text-base">
      <Link
        className="flex items-center h-10 gap-3 px-2 hover:bg-blue-95"
        to="/"
        onClick={() => setCloseSettingsPanel(false)}
      >
        <Settings24Regular className=" text-blue-00" />
        {t('menu.setting')}
      </Link>
      <Link
        className="flex items-center h-10 gap-3 px-2 hover:bg-blue-95 "
        to="/"
        onClick={() => setCloseSettingsPanel(false)}
      >
        <Info24Regular className=" text-blue-00" />
        {t('menu.aboutUs')}
      </Link>

      <div
        className="flex items-center h-10 gap-3 px-2 cursor-pointer hover:bg-blue-95"
        onClick={logout}
      >
        <ArrowExitRegular className="text-2xl  text-blue-00" />
        {t('menu.logout')}
      </div>
    </div>
  );
};

SettingMenu.defaultProps = {
  logout: () => ({}),
};
export default SettingMenu;
